<template>
    <div
        class="app-container"
        v-loading="openloading"
        element-loading-text="加载中"
        element-loading-background="rgba(0, 0, 0, 0.1)"
    >
        <!-- <el-row style="padding-bottom: 15px;">
      <el-col :span="24">
        <h3 class="headtitle">基础档案维护</h3>
        <span>基础档案</span>
      </el-col>
    </el-row> -->
        <el-card>
            <el-row>
                <el-col :span="18">
                    <div class="menuSection">
                        <div class="menu-up">
                            <span class="font-14 right-20">模块:</span>
                            <el-button
                                v-for="(item, index) in lstBusinessModules"
                                :key="item.id"
                                size="medium"
                                :type="CurrnetIndex == index ? 'primary' : ''"
                                @click="moduleChange(item, index)"
                                >{{ item.name }}</el-button
                            >
                        </div>
                    </div>
                </el-col>
                <el-col :span="6">
                    <el-input
                        placeholder="搜索"
                        v-model="formInLine.Filter"
                        size="medium"
                        suffix-icon="el-icon-search"
                        v-on:input="search"
                    ></el-input>
                </el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :span="24">
                    <div class="menuSection">
                        <span class="font-14 right-20">品牌:</span>
                        <el-select
                            v-model="brandId"
                            placeholder="选择品牌"
                            size="mini"
                            @change="brandChange"
                            v-if="brandList != null && brandList.length > 0"
                        >
                            <el-option
                                v-for="item in brandList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id"
                            ></el-option>
                        </el-select>
                    </div>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24">
                    <div class="menuSelect">
                        <ul>
                            <li
                                v-for="item in ArchList"
                                :key="item.basicData.name"
                            >
                                <item
                                    :item="item"
                                    :moduleID="formInLine.moduleID"
                                    :brandId="brandId"
                                    :enumMark="formInLine.enumMark"
                                ></item>
                            </li>
                        </ul>
                    </div>
                </el-col>
            </el-row>
        </el-card>
    </div>
</template>

<script>
import axios from 'axios'
import config from '@/common/config.js'
import AjaxHelper from '@/common/js/AjaxHelper'
// import fileUpload from "@/views/bench/fileuploadTemp";
import item from '@/views/bench/Item'
export default {
    name: 'benchindex',
    components: {
        item
    },
    data() {
        return {
            openloading: true,
            basicDataListUrl: config.BASE_Middle_API + 'BasicDataList', //基础档案
            lstBusinessModules: [],
            CurrnetIndex: 0,
            formInLine: {
                moduleID: '',
                Filter: '',
                BrandId: ''
            },
            Modules: [], //所属类目
            dialogVisible: false,
            ArchList: [], //基础档案列表
            // //上传的文件
            fileList: [],
            // CurrnetMID: 0,
            // CurrentModuleID: 0,
            // CurrentEnumMark:'',
            brands: [],
            brandList: [],
            brandId: null
        }
    },

    mounted() {
        this.formInLine.moduleID = 0
        this.initBusinessModules()
    },
    methods: {
        moduleChange(item, index) {
            this.CurrnetIndex = index
            this.formInLine.moduleID = item.moduleID
            this.formInLine.enumMark = item.enumMark
            this.brandList = this.brands.filter((x) => x.moduleID == item.id)
            if (this.brandList != null && this.brandList.length > 0) {
                this.brandId = this.brandList[0].id
                this.formInLine.BrandId = this.brandId
            }
            this.initData()
        },
        search: function (e) {
            this.initData()
        },
        brandChange(val) {
            console.log(val)
            this.formInLine.BrandId = val
            this.initData()
        },
        initData() {
            const _this = this
            if (
                _this.formInLine.BrandId != null &&
                _this.formInLine.BrandId != ''
            ) {
                AjaxHelper.get(
                    _this.basicDataListUrl + '/GetList',
                    _this.formInLine
                )
                    .then(function (response) {
                        if (response.success) {
                            _this.ArchList = response.result
                            _this.openloading = false
                        }
                    })
                    .catch(function (error) {
                        _this.openloading = false
                        console.log(error)
                    })
            } else {
                _this.openloading = false
            }
        },
        initBusinessModules() {
            const _this = this
            AjaxHelper.get(_this.basicDataListUrl + '/GetModules')
                .then(function (response) {
                    if (response.success) {
                        _this.lstBusinessModules =
                            response.result.purchasedModules
                        if (
                            _this.lstBusinessModules != null &&
                            _this.lstBusinessModules.length > 0
                        ) {
                            var firstItem = _this.lstBusinessModules[0]
                            // _this.CurrnetMID = firstItem.id;
                            // _this.CurrentModuleID = firstItem.moduleID;

                            if (
                                !$.isEmptyObject(_this.$route.query) &&
                                !!_this.$route.query.moduleID
                            ) {
                                _this.formInLine.moduleID =
                                    _this.$route.query.moduleID
                                _this.lstBusinessModules.forEach(
                                    (item, index) => {
                                        if (
                                            item.moduleID ==
                                            _this.formInLine.moduleID
                                        ) {
                                            _this.CurrnetIndex = index
                                            firstItem = item
                                        }
                                    }
                                )
                            }

                            _this.formInLine.moduleID = firstItem.moduleID
                            _this.formInLine.enumMark = firstItem.enumMark

                            _this.brands = response.result.brands
                            _this.stores = response.result.stores
                            _this.brandList = response.result.brands.filter(
                                (x) => x.moduleID == firstItem.id
                            )

                            if (
                                _this.brandList != null &&
                                _this.brandList.length > 0
                            ) {
                                _this.brandId = _this.brandList[0].id
                                _this.formInLine.BrandId = _this.brandId

                                if (
                                    !$.isEmptyObject(_this.$route.query) &&
                                    !!_this.$route.query.brandId
                                ) {
                                    _this.brandId = _this.$route.query.brandId
                                    _this.formInLine.BrandId = _this.brandId
                                }
                            }
                        }
                        _this.initData()
                    }
                })
                .catch(function (error) {
                    _this.openloading = false
                    console.log(error)
                })
        },
        initBrands() {
            const _this = this
            AjaxHelper.get(_this.basicDataListUrl + '/GetEnableData')
                .then(function (response) {
                    if (response.success) {
                        _this.lstBusinessModules = response.result
                        _this.lstBusinessModules.unshift({
                            moduleName: '全部',
                            id: 0
                        })
                        _this.initBrands()
                    }
                })
                .catch(function (error) {
                    console.log(error)
                })
        }
    }
}
</script>

<style scoped>
.menuBg .upload-demo {
    text-align: center;
    padding: 0 15px 10px 15px;
}
.menuBg h4 {
    text-align: center;
    width: 100%;
    font-size: 18px;
    font-weight: 600;
    margin-top: 35px;
    display: inline-block;
    color: #d4e9fd;
}

.menuDown {
    padding: 12px 0;
}

.menuDown i,
.menuDown strong {
    display: inline-block;
    margin-right: 10px;
    font-size: 16px;
    cursor: pointer;
}

.menuSelect ul {
    display: flex;
    flex-wrap: wrap;
}

.menuSelect ul li {
    flex-basis: 22%;
    min-width: 280px !important;
    flex-grow: 1;
    border: 1px #ebeef5 solid;
    margin: 10px;
}
.menu-up {
    padding-bottom: 10px;
}
.menu-up .el-button {
    border: none !important;
}

.loglists li {
    padding: 10px 0;
    font-size: 14px;
    color: #999999;
}

.loglists .el-tag {
    margin-right: 15px;
}
.el-card {
    height: calc(100vh - 155px) !important;
}
</style>